module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('b-field', {
    attrs: {
      "grouped": "",
      "group-multiline": ""
    }
  }, [_c('b-select', {
    model: {
      value: (_vm.defaultSortDirection),
      callback: function($$v) {
        _vm.defaultSortDirection = $$v
      },
      expression: "defaultSortDirection"
    }
  }, [_c('option', {
    attrs: {
      "value": "asc"
    }
  }, [_vm._v("Default sort direction: ASC")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "desc"
    }
  }, [_vm._v("Default sort direction: DESC")])]), _vm._v(" "), _c('b-select', {
    attrs: {
      "disabled": !_vm.isPaginated
    },
    model: {
      value: (_vm.perPage),
      callback: function($$v) {
        _vm.perPage = $$v
      },
      expression: "perPage"
    }
  }, [_c('option', {
    attrs: {
      "value": "5"
    }
  }, [_vm._v("5 per page")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "10"
    }
  }, [_vm._v("10 per page")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "15"
    }
  }, [_vm._v("15 per page")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "20"
    }
  }, [_vm._v("20 per page")])]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button",
    attrs: {
      "disabled": !_vm.isPaginated
    },
    on: {
      "click": function($event) {
        _vm.currentPage = 2
      }
    }
  }, [_vm._v("Set page to 2")])]), _vm._v(" "), _c('div', {
    staticClass: "control is-flex"
  }, [_c('b-switch', {
    model: {
      value: (_vm.isPaginated),
      callback: function($$v) {
        _vm.isPaginated = $$v
      },
      expression: "isPaginated"
    }
  }, [_vm._v("Paginated")])], 1), _vm._v(" "), _c('div', {
    staticClass: "control is-flex"
  }, [_c('b-switch', {
    attrs: {
      "disabled": !_vm.isPaginated
    },
    model: {
      value: (_vm.isPaginationSimple),
      callback: function($$v) {
        _vm.isPaginationSimple = $$v
      },
      expression: "isPaginationSimple"
    }
  }, [_vm._v("Simple pagination")])], 1), _vm._v(" "), _c('b-select', {
    attrs: {
      "disabled": !_vm.isPaginated
    },
    model: {
      value: (_vm.paginationPosition),
      callback: function($$v) {
        _vm.paginationPosition = $$v
      },
      expression: "paginationPosition"
    }
  }, [_c('option', {
    attrs: {
      "value": "bottom"
    }
  }, [_vm._v("bottom pagination")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "top"
    }
  }, [_vm._v("top pagination")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "both"
    }
  }, [_vm._v("both")])]), _vm._v(" "), _c('b-select', {
    model: {
      value: (_vm.sortIcon),
      callback: function($$v) {
        _vm.sortIcon = $$v
      },
      expression: "sortIcon"
    }
  }, [_c('option', {
    attrs: {
      "value": "arrow-up"
    }
  }, [_vm._v("Arrow sort icon")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "menu-up"
    }
  }, [_vm._v("Caret sort icon")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "chevron-up"
    }
  }, [_vm._v("Chevron sort icon ")])]), _vm._v(" "), _c('b-select', {
    model: {
      value: (_vm.sortIconSize),
      callback: function($$v) {
        _vm.sortIconSize = $$v
      },
      expression: "sortIconSize"
    }
  }, [_c('option', {
    attrs: {
      "value": "is-small"
    }
  }, [_vm._v("Small sort icon")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Regular sort icon")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "is-medium"
    }
  }, [_vm._v("Medium sort icon")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "is-large"
    }
  }, [_vm._v("Large sort icon")])])], 1), _vm._v(" "), _c('b-table', {
    attrs: {
      "data": _vm.data,
      "paginated": _vm.isPaginated,
      "per-page": _vm.perPage,
      "current-page": _vm.currentPage,
      "pagination-simple": _vm.isPaginationSimple,
      "pagination-position": _vm.paginationPosition,
      "default-sort-direction": _vm.defaultSortDirection,
      "sort-icon": _vm.sortIcon,
      "sort-icon-size": _vm.sortIconSize,
      "default-sort": "user.first_name",
      "aria-next-label": "Next page",
      "aria-previous-label": "Previous page",
      "aria-page-label": "Page",
      "aria-current-label": "Current page"
    },
    on: {
      "update:currentPage": function($event) {
        _vm.currentPage = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('b-table-column', {
          attrs: {
            "field": "id",
            "label": "ID",
            "width": "40",
            "sortable": "",
            "numeric": ""
          }
        }, [_vm._v("\n                    " + _vm._s(props.row.id) + "\n                ")]), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "field": "user.first_name",
            "label": "First Name",
            "sortable": ""
          }
        }, [_vm._v("\n                    " + _vm._s(props.row.user.first_name) + "\n                ")]), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "field": "user.last_name",
            "label": "Last Name",
            "sortable": ""
          }
        }, [_vm._v("\n                    " + _vm._s(props.row.user.last_name) + "\n                ")]), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "field": "date",
            "label": "Date",
            "sortable": "",
            "centered": ""
          }
        }, [_c('span', {
          staticClass: "tag is-success"
        }, [_vm._v("\n                        " + _vm._s(new Date(props.row.date).toLocaleDateString()) + "\n                    ")])]), _vm._v(" "), _c('b-table-column', {
          attrs: {
            "label": "Gender"
          }
        }, [_c('span', [_c('b-icon', {
          attrs: {
            "pack": "fas",
            "icon": props.row.gender === 'Male' ? 'mars' : 'venus'
          }
        }), _vm._v("\n                        " + _vm._s(props.row.gender) + "\n                    ")], 1)])]
      }
    }])
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-176a15ae"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./docs/pages/components/table/examples/ExPaginationSort.vue
// module id = 1209
// module chunks = 1 57